import React, { useContext, useEffect, useState } from 'react';
import { getTranslation, isAppleRoute } from '../../../helpers';
import { countryConstants, englishVariant } from './CountryConstants';
import { LanguageContext } from './LanguageContext';

const useTranslation = () =>
    // path
    {
        // const [translations, setTranslations] = useState({})
        // const [englishVariant, setEnglishVariant] = useState('american');

        const context = useContext(LanguageContext);
        const { country, language, englishVars, countryVars } = context ?? {};

        // const translations = getTranslation(language, path)

        // useEffect(()=> {

        //     /**
        //      * if (!apple) {
        //      *  setData({
        //      *      langAndCountry: 'en-US'
        //      *      lang: 'en',
        //      *      country: 'US',
        //      *  })
        //      *  return
        //      * }
        //      *
        //      */
        //     getTranslation(path, language) //setData at the end of this function
        //     setTranslations(result)
        //     return
        // },[])

        if (!isAppleRoute())
            return {
                country: 'US',
                language: 'en',
                englishVars: englishVariant.american,
                countryVars: countryConstants.US,
                translations: {}
            };

        return {
            country,
            language,
            englishVars,
            countryVars,
            translations: {} // UPDATE WHEN TRANSLATION SUPPORTED
        };
    };

export default useTranslation;
